module.exports = __webpack_public_path__ + "static/media/addPhoto.7ce525e2.png";